import { FixaInputField } from "@coworker/apprestructured/src/shared/wrappers/FixaInputField/FixaInputField";
import InputWrapper from "@coworker/apprestructured/src/task-management/components/InputWrapper/InputWrapper";
import { memo } from "react";
import { useTranslation } from "@coworker/locales";

interface CustomLocationTabProps {
  customLocation: string;
  onCustomLocationChange: (newCustomLocation: string) => void;
}

export const CustomLocationTab = memo(
  ({ customLocation, onCustomLocationChange }: CustomLocationTabProps) => {
    const { t } = useTranslation();
    return (
      <InputWrapper>
        <FixaInputField
          type="text"
          label={t("location3String")}
          id="custom-location-input"
          data-testid="custom-location-input"
          value={customLocation}
          onChange={(e) => onCustomLocationChange(e.target.value)}
        />
      </InputWrapper>
    );
  }
);
